import React, { useState } from "react";
import { FaSearch, FaTimes, FaFilter } from "react-icons/fa";

const BEDROOM_OPTIONS = ["", 1, 2, 3, 4, 5, 6];
const BATHROOM_OPTIONS = ["", 1, 2, 3, 4, 5, 6];
const FURNISHING_OPTIONS = [
  { value: "", label: "Semua Furnishing" },
  { value: "furnished", label: "Furnished" },
  { value: "semi_furnished", label: "Semi Furnished" },
  { value: "unfurnished", label: "Unfurnished" },
];

const PropertyFilters = (props) => {
  const {
    search, onSearchChange, status, onStatusChange, sort, onSortChange,
    propertyType, onPropertyTypeChange, city, onCityChange, province, onProvinceChange,
    propertyTypes, cities, provinces, districts, district, onDistrictChange,
    bedrooms, onBedroomsChange, bathrooms, onBathroomsChange, furnishing, onFurnishingChange,
    priceMin, onPriceMinChange, priceMax, onPriceMaxChange, onClear,
  } = props;
  const [drawerOpen, setDrawerOpen] = useState(false);

  const drawerFilters = [
    { label: 'Status', value: status, onChange: onStatusChange, options: [
      { value: 'all', label: 'Semua Status' }, { value: 'for_sale', label: 'Dijual' }, { value: 'for_rent', label: 'Sewa' },
    ]},
    { label: 'Urutkan', value: sort, onChange: onSortChange, options: [
      { value: 'latest', label: 'Terbaru' }, { value: 'price_asc', label: 'Harga Terendah' }, { value: 'price_desc', label: 'Harga Tertinggi' },
    ]},
  ];

  if (Array.isArray(propertyTypes) && propertyTypes.length > 0) {
    drawerFilters.push({ label: 'Tipe Properti', value: propertyType || '', onChange: onPropertyTypeChange,
      options: [{ value: '', label: 'Semua Tipe' }, ...propertyTypes.map(t => ({ value: t, label: t }))] });
  }
  if (Array.isArray(provinces) && provinces.length > 0) {
    drawerFilters.push({ label: 'Provinsi', value: province || '', onChange: onProvinceChange,
      options: [{ value: '', label: 'Semua Provinsi' }, ...provinces.map(p => ({ value: p, label: p }))] });
  }
  if (Array.isArray(cities) && cities.length > 0) {
    drawerFilters.push({ label: 'Kota', value: city || '', onChange: onCityChange,
      options: [{ value: '', label: 'Semua Kota' }, ...cities.map(c => ({ value: c, label: c }))] });
  }
  if (Array.isArray(districts) && districts.length > 0) {
    drawerFilters.push({ label: 'Kecamatan', value: district || '', onChange: onDistrictChange,
      options: [{ value: '', label: 'Semua Kecamatan' }, ...districts.map(d => ({ value: d, label: d }))] });
  }
  if (typeof onBedroomsChange === 'function') {
    drawerFilters.push({ label: 'Kamar Tidur', value: bedrooms ?? '', onChange: onBedroomsChange,
      options: [{ value: '', label: 'Semua Kamar Tidur' }, ...BEDROOM_OPTIONS.filter(Boolean).map(n => ({ value: n, label: n + '+' }))] });
  }
  if (typeof onBathroomsChange === 'function') {
    drawerFilters.push({ label: 'Kamar Mandi', value: bathrooms ?? '', onChange: onBathroomsChange,
      options: [{ value: '', label: 'Semua Kamar Mandi' }, ...BATHROOM_OPTIONS.filter(Boolean).map(n => ({ value: n, label: n + '+' }))] });
  }
  if (typeof onFurnishingChange === 'function') {
    drawerFilters.push({ label: 'Furnishing', value: furnishing ?? '', onChange: onFurnishingChange,
      options: FURNISHING_OPTIONS.map(o => ({ value: o.value, label: o.label })) });
  }

  const activeCount = [status, sort, propertyType, city, province, district,
    bedrooms, bathrooms, furnishing, priceMin, priceMax,
  ].filter(v => v !== undefined && v !== null && v !== '' && v !== 'all').length;

  return (
    <>
      <div className="property-filters">
        <div className="search-box">
          <FaSearch className="search-icon" />
          <input type="text" value={search} onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Cari rumah, lokasi, atau tipe properti..." className="search-input" />
        </div>
        <div className="filters-desktop">
          <select value={status} onChange={(e) => onStatusChange(e.target.value)} className="filter-select">
            <option value="all">Semua Status</option><option value="for_sale">Dijual</option><option value="for_rent">Sewa</option>
          </select>
          <select value={sort} onChange={(e) => onSortChange(e.target.value)} className="filter-select">
            <option value="latest">Terbaru</option><option value="price_asc">Harga Terendah</option><option value="price_desc">Harga Tertinggi</option>
          </select>
          {Array.isArray(propertyTypes) && propertyTypes.length > 0 && (
            <select value={propertyType || ''} onChange={(e) => onPropertyTypeChange(e.target.value)} className="filter-select">
              <option value="">Semua Tipe</option>{propertyTypes.map(t => (<option key={t} value={t}>{t}</option>))}
            </select>
          )}
          {Array.isArray(cities) && cities.length > 0 && (
            <select value={city || ''} onChange={(e) => onCityChange(e.target.value)} className="filter-select">
              <option value="">Semua Kota</option>{cities.map(c => (<option key={c} value={c}>{c}</option>))}
            </select>
          )}
          {Array.isArray(provinces) && provinces.length > 0 && (
            <select value={province || ''} onChange={(e) => onProvinceChange(e.target.value)} className="filter-select">
              <option value="">Semua Provinsi</option>{provinces.map(p => (<option key={p} value={p}>{p}</option>))}
            </select>
          )}
          {Array.isArray(districts) && districts.length > 0 && (
            <select value={district || ''} onChange={(e) => onDistrictChange(e.target.value)} className="filter-select">
              <option value="">Semua Kecamatan</option>{districts.map(d => (<option key={d} value={d}>{d}</option>))}
            </select>
          )}
          {typeof onBedroomsChange === 'function' && (
            <select value={bedrooms ?? ''} onChange={(e) => onBedroomsChange(e.target.value)} className="filter-select">
              <option value="">Semua Kamar Tidur</option>{BEDROOM_OPTIONS.filter(Boolean).map(n => (<option key={n} value={n}>{n}+</option>))}
            </select>
          )}
          {typeof onBathroomsChange === 'function' && (
            <select value={bathrooms ?? ''} onChange={(e) => onBathroomsChange(e.target.value)} className="filter-select">
              <option value="">Semua Kamar Mandi</option>{BATHROOM_OPTIONS.filter(Boolean).map(n => (<option key={n} value={n}>{n}+</option>))}
            </select>
          )}
          {typeof onFurnishingChange === 'function' && (
            <select value={furnishing ?? ''} onChange={(e) => onFurnishingChange(e.target.value)} className="filter-select">
              {FURNISHING_OPTIONS.map(opt => (<option key={opt.value} value={opt.value}>{opt.label}</option>))}
            </select>
          )}
          {typeof onPriceMinChange === 'function' && (
            <input type="number" value={priceMin ?? ''} onChange={(e) => onPriceMinChange(e.target.value)} placeholder="Harga Min" className="filter-select" min="0" />
          )}
          {typeof onPriceMaxChange === 'function' && (
            <input type="number" value={priceMax ?? ''} onChange={(e) => onPriceMaxChange(e.target.value)} placeholder="Harga Max" className="filter-select" min="0" />
          )}
          <button type="button" className="clear-filter-btn" onClick={onClear}><FaTimes /> Reset</button>
        </div>
        <button type="button" className="filter-mobile-toggle" onClick={() => setDrawerOpen(true)}>
          <FaFilter size={14} /> <span>Filter</span>
          {activeCount > 0 && <span className="filter-active-badge">{activeCount}</span>}
        </button>
      </div>
      {drawerOpen && (
        <div className="filter-drawer-overlay" onClick={() => setDrawerOpen(false)}>
          <div className="filter-drawer" onClick={(e) => e.stopPropagation()}>
            <div className="filter-drawer-header">
              <h3>Filter</h3>
              <button type="button" className="filter-drawer-close" onClick={() => setDrawerOpen(false)}><FaTimes size={16} /></button>
            </div>
            <div className="filter-drawer-body">
              {drawerFilters.map(f => (
                <div className="filter-drawer-group" key={f.label}>
                  <label className="filter-drawer-label">{f.label}</label>
                  <select value={f.value} onChange={(e) => f.onChange(e.target.value)} className="filter-drawer-select">
                    {f.options.map(o => (<option key={o.value} value={o.value}>{o.label}</option>))}
                  </select>
                </div>
              ))}
              {(typeof onPriceMinChange === 'function' || typeof onPriceMaxChange === 'function') && (
                <div className="filter-drawer-group">
                  <label className="filter-drawer-label">Rentang Harga</label>
                  <div className="filter-drawer-price-row">
                    {typeof onPriceMinChange === 'function' && (
                      <input type="number" value={priceMin ?? ''} onChange={(e) => onPriceMinChange(e.target.value)} placeholder="Min" className="filter-drawer-input" min="0" />
                    )}
                    <span className="filter-drawer-price-sep">—</span>
                    {typeof onPriceMaxChange === 'function' && (
                      <input type="number" value={priceMax ?? ''} onChange={(e) => onPriceMaxChange(e.target.value)} placeholder="Max" className="filter-drawer-input" min="0" />
                    )}
                  </div>
                </div>
              )}
              <div className="filter-drawer-actions">
                <button type="button" className="filter-drawer-reset" onClick={() => { onClear(); setDrawerOpen(false); }}><FaTimes /> Reset Semua</button>
                <button type="button" className="filter-drawer-apply" onClick={() => setDrawerOpen(false)}>Terapkan Filter</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PropertyFilters;
